import { EyeClosed } from "@phosphor-icons/react";
import { Grid, Heading, Text } from "@radix-ui/themes";
import { Link as NavLink } from "@tanstack/react-router";

import { indexRoute } from "../index/route";

export function EmptyWorkflowsView() {
  return (
    <Grid
      gap="4"
      className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center"
    >
      <EyeClosed
        size={48}
        color="rgb(var(--puntt-blue-9))"
        className="mx-auto"
      />

      <Heading size="6" color="gray">
        Nothing to see here. Yet.
      </Heading>

      <Text size="3" color="gray">
        Visit{" "}
        <NavLink className="puntt-link" to={indexRoute.to}>
          Home
        </NavLink>{" "}
        to start a new workflow.
      </Text>
    </Grid>
  );
}
